/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConfig.defs.js'
export * as $defs from './getConfig.defs.js'
